import { useQuery } from "@tanstack/react-query";
import { getIntensityEmbedUrl } from "api";
import { QUERY_KEYS } from "consts";

export const useGetIntensityUrl = () =>
  useQuery<{ embedUrl: string }>([QUERY_KEYS.INTENSITY_EMBED_URL], getIntensityEmbedUrl);
